var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlog1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 248,
    viewBox: "0 0 280 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1736_60881)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120.672,
    height: 162.704,
    rx: 4.86338,
    transform: "matrix(0.999983 0.00584507 -0.235734 0.971818 119.563 31.5957)",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5409,
    cy: 32.5409,
    r: 32.0889,
    transform: "matrix(0.999983 0.00584507 -0.235734 0.971818 138.956 67.3301)",
    stroke: "white",
    strokeWidth: 0.903913
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.085 96.9358C186.347 95.8522 186.281 94.7899 185.896 93.875C185.511 92.96 184.822 92.2309 183.912 91.7742C183.001 91.3175 181.908 91.1524 180.761 91.2985C179.613 91.4447 178.461 91.8959 177.44 92.5986C174.747 91.0064 171.318 90.0298 167.543 89.7952L169.834 84.282L173.679 84.9067C173.624 85.9024 173.952 86.804 174.603 87.4519C175.254 88.0999 176.186 88.4523 177.235 88.4468C178.284 88.4413 179.382 88.0782 180.334 87.4219C181.285 86.7655 182.03 85.8582 182.436 84.8608C182.841 83.8633 182.882 82.8399 182.55 81.9719C182.218 81.104 181.535 80.4474 180.622 80.1185C179.71 79.7896 178.626 79.8096 177.563 80.1749C176.499 80.5403 175.526 81.2274 174.814 82.1146L169.575 81.2692C169.208 81.2108 168.797 81.2995 168.433 81.5162C168.068 81.7329 167.778 82.0601 167.626 82.4269L164.582 89.7601C160.553 89.896 156.477 90.8287 152.875 92.455C151.934 91.5154 150.549 91.0473 149.012 91.1488C147.474 91.2504 145.904 91.9137 144.63 92.9997C143.356 94.0856 142.478 95.5096 142.179 96.9727C141.881 98.4359 142.186 99.8244 143.03 100.847C142.523 101.795 142.143 102.776 141.901 103.763C140.962 107.637 142.279 111.276 145.64 113.97C149 116.664 153.589 118.002 158.97 118.033C164.352 118.065 169.766 116.679 174.232 114.137C178.698 111.595 181.965 107.876 182.905 104.003C183.142 103.021 183.237 102.044 183.187 101.099C183.91 100.568 184.54 99.9249 185.038 99.2088C185.537 98.4928 185.893 97.7191 186.085 96.9358ZM152.667 101.7C152.803 101.14 153.107 100.594 153.542 100.131C153.977 99.6672 154.522 99.3071 155.109 99.096C155.696 98.885 156.299 98.8324 156.841 98.9449C157.382 99.0574 157.839 99.33 158.152 99.7282C158.466 100.126 158.622 100.632 158.602 101.182C158.582 101.732 158.386 102.3 158.039 102.816C157.692 103.332 157.209 103.772 156.652 104.08C156.095 104.388 155.489 104.551 154.909 104.547C154.133 104.543 153.46 104.24 153.039 103.706C152.619 103.172 152.485 102.451 152.667 101.7ZM167.443 110.838C165.115 111.861 162.681 112.387 160.343 112.373C158.006 112.36 155.834 111.806 154.007 110.76C153.733 110.573 153.57 110.277 153.552 109.93C153.533 109.584 153.661 109.214 153.909 108.895C154.156 108.577 154.505 108.333 154.885 108.214C155.265 108.096 155.647 108.11 155.953 108.256C157.416 109.094 159.157 109.537 161.029 109.548C162.901 109.559 164.851 109.137 166.716 108.319C167.092 108.177 167.48 108.167 167.801 108.29C168.122 108.413 168.352 108.66 168.445 108.98C168.537 109.301 168.485 109.671 168.299 110.016C168.113 110.362 167.807 110.655 167.443 110.838ZM169.553 104.633C168.974 104.63 168.448 104.46 168.042 104.147C167.636 103.833 167.368 103.389 167.271 102.87C167.175 102.352 167.255 101.782 167.501 101.234C167.747 100.686 168.149 100.183 168.654 99.7896C169.16 99.3962 169.747 99.1297 170.342 99.0238C170.936 98.9179 171.512 98.9774 171.995 99.1947C172.478 99.4121 172.848 99.7775 173.057 100.245C173.265 100.712 173.305 101.26 173.169 101.82C172.987 102.571 172.503 103.289 171.825 103.816C171.147 104.344 170.33 104.638 169.553 104.633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.345407,
    y: 0.441861,
    width: 119.769,
    height: 161.801,
    rx: 4.41142,
    transform: "matrix(0.999983 0.00584507 -0.235734 0.971818 119.668 31.6061)",
    stroke: "white",
    strokeWidth: 0.903913
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1736_60881)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120.672,
    height: 162.704,
    rx: 4.86338,
    transform: "matrix(0.999983 0.00584507 -0.235734 0.971818 96.8169 60.1172)",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5409,
    cy: 32.5409,
    r: 32.0889,
    transform: "matrix(0.999983 0.00584507 -0.235734 0.971818 116.208 95.8516)",
    stroke: "white",
    strokeWidth: 0.903913
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.338 125.455C163.6 124.372 163.534 123.309 163.149 122.395C162.763 121.48 162.075 120.75 161.164 120.294C160.254 119.837 159.16 119.672 158.013 119.818C156.866 119.964 155.714 120.415 154.693 121.118C151.999 119.526 148.57 118.549 144.796 118.315L147.086 112.802L150.931 113.426C150.877 114.422 151.204 115.324 151.855 115.971C152.506 116.619 153.439 116.972 154.488 116.966C155.537 116.961 156.634 116.598 157.586 115.941C158.538 115.285 159.283 114.378 159.688 113.38C160.094 112.383 160.134 111.359 159.803 110.491C159.471 109.623 158.788 108.967 157.875 108.638C156.962 108.309 155.878 108.329 154.815 108.694C153.752 109.06 152.778 109.747 152.067 110.634L146.827 109.789C146.46 109.73 146.05 109.819 145.685 110.036C145.32 110.252 145.03 110.58 144.878 110.946L141.835 118.28C137.805 118.416 133.73 119.348 130.127 120.975C129.186 120.035 127.801 119.567 126.264 119.668C124.727 119.77 123.156 120.433 121.882 121.519C120.608 122.605 119.73 124.029 119.432 125.492C119.134 126.955 119.438 128.344 120.283 129.366C119.775 130.315 119.396 131.296 119.154 132.282C118.214 136.156 119.531 139.795 122.892 142.489C126.253 145.184 130.841 146.521 136.223 146.553C141.605 146.584 147.018 145.199 151.485 142.657C155.951 140.114 159.218 136.396 160.157 132.522C160.394 131.541 160.489 130.564 160.44 129.619C161.162 129.088 161.792 128.444 162.291 127.728C162.789 127.012 163.146 126.239 163.338 125.455ZM129.919 130.22C130.055 129.66 130.36 129.114 130.794 128.65C131.229 128.187 131.775 127.827 132.362 127.616C132.949 127.404 133.551 127.352 134.093 127.464C134.635 127.577 135.091 127.85 135.405 128.248C135.718 128.646 135.875 129.152 135.855 129.701C135.835 130.251 135.639 130.82 135.291 131.336C134.944 131.852 134.462 132.291 133.905 132.599C133.348 132.908 132.741 133.07 132.162 133.067C131.385 133.062 130.712 132.76 130.292 132.226C129.871 131.692 129.737 130.97 129.919 130.22ZM144.696 139.358C142.367 140.38 139.933 140.907 137.596 140.893C135.259 140.879 133.086 140.326 131.26 139.279C130.985 139.093 130.823 138.796 130.804 138.45C130.786 138.104 130.914 137.734 131.161 137.415C131.409 137.096 131.758 136.853 132.138 136.734C132.517 136.615 132.899 136.63 133.205 136.775C134.669 137.613 136.409 138.056 138.281 138.067C140.153 138.078 142.103 137.657 143.969 136.838C144.345 136.697 144.733 136.686 145.054 136.809C145.375 136.932 145.605 137.179 145.697 137.5C145.79 137.82 145.738 138.191 145.552 138.536C145.366 138.881 145.06 139.175 144.696 139.358ZM146.806 133.153C146.227 133.149 145.701 132.98 145.294 132.666C144.888 132.352 144.62 131.908 144.524 131.39C144.428 130.871 144.508 130.302 144.754 129.753C145 129.205 145.401 128.703 145.907 128.309C146.412 127.916 147 127.649 147.594 127.543C148.189 127.437 148.764 127.497 149.247 127.714C149.731 127.932 150.1 128.297 150.309 128.764C150.518 129.232 150.557 129.78 150.421 130.34C150.239 131.09 149.756 131.808 149.078 132.336C148.4 132.863 147.583 133.157 146.806 133.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.345407,
    y: 0.441861,
    width: 119.769,
    height: 161.801,
    rx: 4.41142,
    transform: "matrix(0.999983 0.00584507 -0.235734 0.971818 96.9211 60.1276)",
    stroke: "white",
    strokeWidth: 0.903913
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1736_60881)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120.672,
    height: 162.704,
    rx: 4.86338,
    transform: "matrix(0.999983 0.00584507 -0.235734 0.971818 86.7183 42.6113)",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5409,
    cy: 32.5409,
    r: 32.0889,
    transform: "matrix(0.999983 0.00584507 -0.235734 0.971818 106.109 78.3496)",
    stroke: "white",
    strokeWidth: 0.903913
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.239 107.955C153.5 106.872 153.435 105.809 153.049 104.895C152.664 103.98 151.975 103.25 151.065 102.794C150.155 102.337 149.061 102.172 147.914 102.318C146.767 102.464 145.614 102.915 144.594 103.618C141.9 102.026 138.471 101.049 134.697 100.815L136.987 95.3015L140.832 95.9262C140.778 96.9219 141.105 97.8235 141.756 98.4715C142.407 99.1194 143.34 99.4718 144.389 99.4663C145.437 99.4608 146.535 99.0977 147.487 98.4414C148.439 97.785 149.183 96.8778 149.589 95.8803C149.995 94.8828 150.035 93.8594 149.703 92.9915C149.372 92.1235 148.689 91.4669 147.776 91.138C146.863 90.8091 145.779 90.8291 144.716 91.1944C143.653 91.5598 142.679 92.2469 141.967 93.1342L136.728 92.2887C136.361 92.2303 135.951 92.3191 135.586 92.5358C135.221 92.7524 134.931 93.0796 134.779 93.4464L131.735 100.78C127.706 100.916 123.631 101.848 120.028 103.475C119.087 102.535 117.702 102.067 116.165 102.168C114.628 102.27 113.057 102.933 111.783 104.019C110.509 105.105 109.631 106.529 109.333 107.992C109.034 109.455 109.339 110.844 110.184 111.866C109.676 112.815 109.296 113.796 109.055 114.782C108.115 118.656 109.432 122.295 112.793 124.989C116.154 127.684 120.742 129.021 126.124 129.053C131.505 129.084 136.919 127.699 141.385 125.157C145.852 122.614 149.118 118.896 150.058 115.022C150.295 114.041 150.39 113.064 150.341 112.119C151.063 111.588 151.693 110.944 152.192 110.228C152.69 109.512 153.046 108.739 153.239 107.955ZM119.82 112.72C119.956 112.16 120.261 111.614 120.695 111.15C121.13 110.687 121.675 110.327 122.263 110.116C122.85 109.904 123.452 109.852 123.994 109.964C124.535 110.077 124.992 110.35 125.306 110.748C125.619 111.146 125.776 111.652 125.756 112.201C125.735 112.751 125.539 113.32 125.192 113.836C124.845 114.352 124.363 114.791 123.805 115.099C123.248 115.408 122.642 115.57 122.063 115.567C121.286 115.562 120.613 115.26 120.193 114.726C119.772 114.192 119.638 113.47 119.82 112.72ZM134.597 121.858C132.268 122.88 129.834 123.407 127.497 123.393C125.159 123.379 122.987 122.826 121.161 121.779C120.886 121.593 120.723 121.296 120.705 120.95C120.687 120.604 120.814 120.234 121.062 119.915C121.31 119.596 121.659 119.353 122.038 119.234C122.418 119.115 122.8 119.13 123.106 119.275C124.57 120.113 126.31 120.556 128.182 120.567C130.054 120.578 132.004 120.157 133.87 119.338C134.246 119.197 134.633 119.186 134.954 119.309C135.275 119.432 135.506 119.679 135.598 120C135.691 120.32 135.639 120.691 135.453 121.036C135.267 121.381 134.961 121.675 134.597 121.858ZM136.707 115.653C136.127 115.649 135.601 115.48 135.195 115.166C134.789 114.852 134.521 114.408 134.425 113.89C134.328 113.371 134.408 112.802 134.655 112.253C134.901 111.705 135.302 111.203 135.808 110.809C136.313 110.416 136.901 110.149 137.495 110.043C138.09 109.937 138.665 109.997 139.148 110.214C139.632 110.432 140.001 110.797 140.21 111.264C140.419 111.732 140.458 112.28 140.322 112.84C140.14 113.59 139.657 114.308 138.979 114.836C138.301 115.363 137.484 115.657 136.707 115.653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.345407,
    y: 0.441861,
    width: 119.769,
    height: 161.801,
    rx: 4.41142,
    transform: "matrix(0.999983 0.00584507 -0.235734 0.971818 86.8224 42.6218)",
    stroke: "white",
    strokeWidth: 0.903913
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.1676 89.4944C32.3554 72.8159 3.54893 82.7363 68.8456 119.791C166.867 181.492 289.161 217.296 210.419 157.251",
    stroke: "white",
    strokeWidth: 1.62113
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7857 145.982C13.2021 175.622 -2.95049 211.397 81.1639 174.402C212.523 122.445 346.517 32.3887 232.216 67.957",
    stroke: "white",
    strokeWidth: 1.62113
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.65981,
    cy: 2.65981,
    r: 2.65981,
    transform: "matrix(1 0 0 -1 71.1904 50.4258)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.7356,
    cy: 3.7356,
    r: 3.7356,
    transform: "matrix(1 0 0 -1 189.288 24.2871)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.249,
    cy: 1.31643,
    r: 1.31643,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.35587,
    cy: 1.35587,
    r: 1.35587,
    transform: "matrix(1 0 0 -1 21.979 105.16)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.35587,
    cy: 1.35587,
    r: 1.35587,
    transform: "matrix(1 0 0 -1 136.231 14.9395)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.4763,
    cy: 120.135,
    r: 0.73657,
    transform: "rotate(-180 45.4763 120.135)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.6765,
    cy: 158.738,
    r: 0.73657,
    transform: "rotate(-180 45.6765 158.738)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.408,
    cy: 49.8611,
    r: 0.73657,
    transform: "rotate(-180 28.408 49.8611)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.71174,
    cy: 2.71174,
    r: 2.71174,
    transform: "matrix(1 0 0 -1 0.078125 164.762)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1736_60881",
    x: 60.9444,
    y: 19.4373,
    width: 199.554,
    height: 199.352,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.10563
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.132
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1736_60881"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1736_60881",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1736_60881",
    x: 38.1978,
    y: 47.9587,
    width: 199.554,
    height: 199.352,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.10563
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.132
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1736_60881"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1736_60881",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1736_60881",
    x: 28.0992,
    y: 30.4529,
    width: 199.554,
    height: 199.352,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.10563
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.132
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1736_60881"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1736_60881",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog1);
export default __webpack_public_path__ + "static/media/blog1.cb624aebc71db935a6947bf1adf93e9b.svg";
export { ForwardRef as ReactComponent };